import gql from 'graphql-tag';

const EnrolledCoursesQuery = gql`
  query EnrolledCoursesQuery($programId: String!) {
    ProgramCurriculumProductsV1 @naptime {
      enrolledCourses(programId: $programId, limit: 50, includes: "typeName,definition") {
        elements {
          id
          programId
          productType
          productItemId
          productState
          program
          programProductMetadata
          targetSkillProfileUserStates
          s12nProgress
          s12nIds
          courseProgress
          programs
          courseSchedules
          programUserCredits
          catalogCourses
          partnerIds
          targetSkillProfiles
        }
      }
    }
  }
`;

export default EnrolledCoursesQuery;
